module.exports = __webpack_public_path__ + "carousel3.c27e704f.png";